import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function FloatingCart() {
  const { totalQuantity, openCart } = useCart();
  if (totalQuantity === 0) return null;
  return (
    <button
      onClick={openCart}
      className="fixed bottom-5 left-5 z-40 px-4 h-14 md:h-16 rounded-full bg-[#D4AF37] hover:bg-[#F3E5AB] text-black flex items-center gap-3 shadow-[0_0_28px_rgba(212,175,55,0.35)] hover:scale-105 transition-transform"
      data-testid="floating-cart-button"
      aria-label={`Open cart (${totalQuantity} items)`}
    >
      <div className="relative">
        <ShoppingBag className="w-5 h-5 md:w-6 md:h-6" />
        <span className="absolute -top-2 -right-2 min-w-[20px] h-[20px] px-1 rounded-full bg-black text-[#D4AF37] text-[0.65rem] font-semibold flex items-center justify-center border border-[#D4AF37]">
          {totalQuantity}
        </span>
      </div>
      <span className="text-[0.7rem] uppercase tracking-[0.22em] font-semibold pr-1 hidden sm:inline">View Bag</span>
    </button>
  );
}
